<div class="p-4">
  <h1 class="text-2xl font-semibold mb-1">
    {{ 'startPage.welcome' | translate: { name: firstName() } }}
  </h1>
  <p class="text-surface-500 mb-4">{{ 'startPage.description' | translate }}</p>

  <div class="@container">
    <div
      class="card-grid grid grid-cols-1 @xl:grid-cols-2 @4xl:grid-cols-3 gap-3"
    >
      @for (group of groups(); track group.labelKey) {
        @for (card of group.cards; track card.routerLink) {
          <p-card>
            <div class="flex flex-col items-center text-center gap-2 h-full justify-between">
              <div class="flex flex-col items-center gap-2">
                @if (group.labelKey) {
                  <span class="uppercase text-xs text-surface-500">
                    {{ group.labelKey | translate }}
                  </span>
                }
                <div class="text-lg font-medium">
                  @if (card.icon) {
                    <i [class]="card.icon" class="mr-2"></i>
                  }
                  {{ card.label | translate }}
                </div>
                <p class="text-surface-500">
                  {{ card.dashboard!.descriptionKey | translate }}
                </p>
              </div>
              <a [routerLink]="card.routerLink">
                <p-button
                  [label]="(card.dashboard!.buttonKey | translate) ?? ''"
                  outlined
                  size="small"
                />
              </a>
            </div>
          </p-card>
        }
      }
    </div>
  </div>
</div>
